/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { useIntl } from 'react-intl'

import BaseFeatureCard from './BaseFeatureCard'

import type { ComponentProps, FC } from 'react'

const AutoOpsFeatureCard: FC<
  Pick<ComponentProps<typeof BaseFeatureCard>, 'onNext' | 'isLoading' | 'isDisabled'>
> = ({ onNext, isLoading, isDisabled }) => {
  const { formatMessage } = useIntl()

  return (
    <BaseFeatureCard
      title='AutoOps'
      description={formatMessage({
        id: 'autoops.description',
        defaultMessage: 'Monitor your Self-managed cluster with AutoOps',
      })}
      features={[
        'Feature 1: Automated scaling',
        'Feature 2: Intelligent monitoring',
        'Feature 3: Predictive maintenance',
      ]}
      nextStepLabel={formatMessage({
        id: 'autoops.nextStepLabel',
        defaultMessage: 'Connect',
      })}
      onNext={onNext}
      isLoading={isLoading}
      isDisabled={isDisabled}
      dataAttributePrefix='autoops'
    />
  )
}

export default AutoOpsFeatureCard
